

function removeFromLocalStorageErrorItem(
  forRemoveTaskId,
  currentTicketId,
  categoryTickets
) {
  //normalize categoryTickets
  if (
    categoryTickets.substring(
      categoryTickets.length,
      categoryTickets.length - 2
    ) === "AB"
  )
    categoryTickets = "ticketsAB";
  else {
    categoryTickets = "ticketsCD";
  }
  //end normalize categoryTickets

  let errorsArray = JSON.parse(localStorage.getItem("errorsArray"));
  let errorsArrayItem = errorsArray.find(
    (el) => parseInt(el.ticketId) === parseInt(currentTicketId) && categoryTickets === el.ticketCategory
  );
  errorsArrayItem.ticketErrors = errorsArrayItem.ticketErrors.filter(
    (el) => el !== forRemoveTaskId
  );

  
/*   if (errorsArrayItem.ticketErrors.length === 0) {
    errorsArray = errorsArray.filter((el)=>el.ticketErrors.length !== 0)
  } */

  localStorage.setItem("errorsArray", JSON.stringify(errorsArray));
}

export default removeFromLocalStorageErrorItem;
